/**
 * @generated SignedSource<<d8c52567044da8192eea9f04db85d9f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type colorField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly color: {
    readonly colorKey: string | null;
  } | null;
  readonly fieldId: string;
  readonly name: string;
  readonly " $fragmentType": "colorField_updateWorkItemAllFieldTypesActionRenderer";
};
export type colorField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: colorField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"colorField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "colorField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraColor",
      "kind": "LinkedField",
      "name": "color",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "colorKey"
        }
      ]
    }
  ],
  "type": "JiraColorField"
};

(node as any).hash = "d565084b3ddceb0c4961cc96e0747547";

export default node;
